import { createContext } from "react";
import { Timezone, Country } from "countries-and-timezones";

export const TimeZoneContext = createContext<{
  timeZone: Timezone;
  region: Country;
  isLoading: boolean;
  isTimezoneMismatch: boolean;
  isTimezoneMismatchAlertOpen: boolean;
  openTimezoneMismatchAlert: () => void;
  changeRegion: (regionObj: Country) => void;
  changeZone: (zoneObj: Timezone) => void;
} | null>(null);
